import * as React from "react";

function SvgGoogleTagManager(props, ref) {
  return (
    <svg
      id="google-tag-manager_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 2469.7 2469.8"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".google-tag-manager_svg__st0{fill:#8ab4f8}"}</style>
      <path
        className="google-tag-manager_svg__st0"
        d="M1449.8 2376L1021 1946.7l921.1-930.5 436.7 436.6-929 923.2z"
      />
      <path
        d="M1452.9 527.1L1016.3 90.4 90.5 1016.2c-120.6 120.5-120.7 315.8-.2 436.4l.2.2 925.8 925.8 428.3-430.3L745 1235.1l707.9-708z"
        fill="#4285f4"
      />
      <path
        className="google-tag-manager_svg__st0"
        d="M2378.7 1016.2L1452.9 90.4c-120.6-120.6-316.1-120.6-436.7 0-120.6 120.6-120.6 316.1 0 436.6l926.3 925.8c120.6 120.6 316.1 120.6 436.6 0 120.6-120.6 120.6-316.1 0-436.6h-.4z"
      />
      <circle cx={1231.2} cy={2163.9} r={306} fill="#246fdb" />
    </svg>
  );
}

export default React.forwardRef(SvgGoogleTagManager);
